import { useEffect } from 'react';
import LoadingBox from '../components/LoadingBox';
import { ADMIN_URL } from '../api';

export default function SigninScreen() {
  useEffect(() => {
    // Redirect to Laravel admin panel for authentication
    window.location.href = ADMIN_URL;
  }, []);

  return <LoadingBox />;
}

